<template>
    <div>
        <loader v-if="pageLoader"></loader>
        <div class="middle_section m-0 text-left">
            <div class="d-flex align-items-center justify-content-center">
                <section class="stepsForm-include border-0 vh-100 w-100" v-if="parseInt(get_user.tier) == 3">
                    <div class="row" v-if="parseInt(get_user.step) == 3">
                        <div class="d-none">{{ans_list}}</div>
                        <div class="col-12 stepBorder box-shadow mb-3" v-for="(val, key, index) in question"
                            v-if="show_question == index">
                            <div class="d-flex align-items-start justify-content-between border-bottom pb-2 mb-3">
                                <div class="d-block">
                                    <h3 class="mb-4">Economic Questionaire </h3>
                                    <p class="qusNo mb-0">{{index+1}} Of {{Object.keys(question).length}}</p>
                                    <p>Answer all these questions in order to upgrade your account to Tier 3 Account.
                                    </p>
                                </div>
                            </div>
                            <div class="query">
                                <h5 class="semibold mb-4">{{index+1}}. {{val.type}}</h5>
                                <h5 class="mb-4">{{val.question}}</h5>
                                <ul class="radioList">
                                    <li v-for="answer in val.answers">
                                        <label class="customRadioButton"> {{answer.answer}}
                                            <input type="radio" :id="val.question_id" :name="val.question_id"
                                                :value="answer.ans_id.toString()"
                                                :class="{ 'selected': ans_list[key] == answer.ans_id}"
                                                v-model="ans_list[key]" v-validate="'required'">
                                            <!-- :class="{ 'selected': ans_list[key] == answer.ans_id}" 
                                                :class="{ 'is-invalid': submitted && errors.has(val.question_id) }" -->
                                            <span class="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                                <!-- <p class="red" v-if="!ans_list[key]">This field is required.</p> -->
                            </div>
                            <div class="submitQuery border-top text-right pt-4 mt-3">
                                <button class="borderBtn" v-on:click.prevent="show_question -= 1"
                                    v-if="show_question != 0">Back</button>
                                <button class="cap_btn text-white disable" v-if="!ans_list[key]">Next</button>
                                <button class="cap_btn text-white" v-on:click.prevent="show_question += 1"
                                    v-else-if="show_question < Object.keys(question).length - 1">Next</button>
                                <button class="cap_btn text-white" v-on:click.prevent="submit()"
                                    v-else-if="show_question == Object.keys(question).length - 1">Submit</button>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else-if="parseInt(get_user.step) == 4">
                        <div class="col-12 stepBorder box-shadow mb-3">
                            <div class="d-flex align-items-start justify-content-between border-bottom pb-2 mb-3">
                                <div class="d-block">
                                    <h3 class="mb-4">Economic Questionaire</h3>
                                    <p>Answer all these questions in order to upgrade your account to Tier 3 Account.
                                    </p>
                                </div>
                            </div>
                            <div class="row" v-if="statAnsNum == 3">
                                <div class="col-12 col-md-6">
                                    <div class="query">
                                        <h5 class="semibold mb-4">{{question_list[3].question_id}}. {{question_list[3].type}}</h5>
                                        <h5 class="mb-4">{{question_list[3].question}}</h5>
                                        <div class="form-group">
                                            <select class="form-control" :name="question_list[3].question_id" v-model="annual_income" v-validate="'required'">
                                                <option :value="ans.ans_id" v-for="ans,key in question_list[3].answers" :key="key">{{ans.answer}}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.first(question_list[3].question_id)"> This field is required </p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="query">
                                        <h5 class="semibold mb-4">&nbsp;</h5>
                                        <h5 class="mb-4">{{question_list[4].question}}</h5>
                                        <div class="form-group">
                                            <select class="form-control" :name="question_list[4].question_id" v-model="net_worth" v-validate="'required'">
                                                <option :value="ans.ans_id" v-for="ans,key in question_list[4].answers" :key="key">{{ans.answer}}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.first(question_list[4].question_id)"> This field is required </p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="query">
                                        <h5 class="semibold mb-4">&nbsp;</h5>
                                        <h5 class="mb-4">{{question_list[5].question}}</h5>
                                        <ul class="radioList">
                                            <li v-for="ans,key in question_list[5].answers">
                                                <label class="customRadioButton">{{ans.answer}}
                                                    <input type="radio" :id="question_list[5].question_id" :name="question_list[5].question_id" :value="ans.ans_id" v-model="source_of_funds" v-validate="'required'">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </li>
                                        </ul>
                                        <p class="error" v-if="errors.first(question_list[5].question_id)"> This field is required </p>
                                    </div>
                                </div>
                                <div class="submitQuery border-top text-right pt-4 mt-3 col-12">
                                    <button class="cap_btn text-white" @click="financialQuesNext()" v-if="parseInt(statAnsNum) == 3">Next</button>
                                </div>
                            </div>
                            <div class="row" v-else-if="statAnsNum == 4">
                                <div class="col-12 col-md-12">
                                    <div class="query">
                                        <h5 class="semibold mb-4">4. {{question_list[6].type}}</h5>
                                        <h5 class="mb-4">{{question_list[6].question}}</h5>
                                        <div class="form-group">
                                            <select class="form-control" :name="question_list[6].question_id" v-model="deposit_amount" v-validate="'required'">
                                                <option :value="ans.ans_id" v-for="ans,key in question_list[6].answers" :key="key">{{ans.answer}}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.first(question_list[6].question_id)"> This field is required </p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <div class="query">
                                        <h5 class="semibold mb-4">&nbsp;</h5>
                                        <h5 class="mb-4">{{question_list[7].question}}</h5>
                                        <div class="form-group">
                                            <select class="form-control" :name="question_list[7].question_id" v-model="withdrawal_amount" v-validate="'required'">
                                                <option :value="ans.ans_id" v-for="ans,key in question_list[7].answers" :key="key">{{ans.answer}}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.first(question_list[7].question_id)"> This field is required </p>
                                    </div>
                                </div>
                                <div class="submitQuery border-top text-right pt-4 mt-3 col-12">
                                    <button class="borderBtn" @click="statAnsNum -= 1" v-if="parseInt(statAnsNum) == 4">Back</button>
                                    <button class="cap_btn text-white" @click.prevent="submitFinancial()">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div clas="row" v-else-if="parseInt(get_user.step) == 5">
                        <div class="col-12 stepBorder box-shadow mb-3" v-for="(val, key, index) in question"
                            v-if="show_question == index">
                            <div class="d-flex align-items-start justify-content-between border-bottom pb-2 mb-3 sourceFund">
                                <div class="d-block">
                                    <h3 class="mb-4">Source of Funds</h3>
                                    <p>In order to get verified, you’ll be required to upload the documents according to the
                                        fund sources you chose before. Please upload a minimum of one financial document.
                                        <span class="pointer types d-inline-flex align-items-center" @click="document_popup=true">
                                            <feather size="14" class="mr-1" type="alert-circle"></feather> Document Types
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="query">
                                <div class="uploadStatements" v-for="item,index in AddMoreDocument">
                                    <h5 class="mb-2">{{'Financial Statements' + (parseInt(index) + 1)}}</h5>
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex align-items-center border statements">
                                        <span class="d-flex"><img src="../../../../static/website/images/uploadFile.svg" alt="Upload" title="Upload" /></span>
                                        <div class="upload-btn-wrapper mx-2">
                                            <button class="btn">Upload a file</button>
                                            <input type="file" :id="'Financial'+index" :name="'Financial'+index" v-validate="'required'" @change="sourceFiles(index,$event.target.files[0])"/>
                                        </div>
                                        <p class="f-12 mb-0 fileNme" v-if="item.name != ''">{{item.name }}</p>
                                        <p class="f-12 mb-0 fileNme" v-else>No File Chosen</p>
                                        <p class="error" v-if="errors.first('Financial'+index)"> This field is required </p>
                                    </div>
                                    <button title="Remove" class="btn-blue-b customButton closePay" @click.prevent="removeDocument(item.id)" v-if="AddMoreDocument.length > 1"><feather size="24" class="mr-1" type="x"></feather></button>
                                    </div>
                                </div>
                            </div>
                            <div class="submitQuery d-flex align-items-center justify-content-end border-top text-right pt-4 mt-3">
                                <button title="Add More" class="mr-3 borderBtn d-flex align-items-center pointer" @click.prevent="AddMore()"> <feather size="18" class="mr-1"  type="plus"></feather> Add</button>
                                <button class="cap_btn text-white" v-on:click.prevent="submitDoc()">Submit</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="stepsForm-include border-0 w-100" v-else-if="parseInt(get_user.tier) == 4 && parseInt(get_user.step) == 6">
                    <div class="row justify-content-center vh-100 align-items-center">
                        <div class="col-12 col-md-6 stepBorder box-shadow mb-3">
                            <div class="pb-2 mb-3 sourceFund text-center">
                                <div class="d-block ">
                                    <h3 class="mb-4">Your Tier 3 is under verification. Please check your ticket for a status update.</h3>
                                </div>
                            </div>
                            <div class="submitQuery border-top text-center pt-4 mt-3">
                                <router-link to="/help-centre" class="cap_btn text-white">Go to SupportPage</router-link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div class="modal show fade vueModal" tabindex="-1" role="dialog" v-if="document_popup">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="mb-0">Document Types</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="document_popup=false">
                        <feather size="24" class="mr-1" type="x"></feather>
                    </button>
                    </div>
                    <div class="modal-body p-4">
                    <p>These are the documents that we accept for a verification:</p>
                    <h6>1. Salary</h6>
                    <p>Payslip, Employer Declaration, Bank Statement showing recent salary credited</p>
                    <h6>2. Investment</h6>
                    <p>FSs (The latest audited or not), Dividends, Bank Statement, Letter from Accountant</p>
                    <h6>3. Inheritance</h6>
                    <p>Bank Statement showing the amount, Court Decision, Lawyer Letter</p>
                    <h6>4. Real Estate</h6>
                    <p>Sale Agreement, Lawyer Letter, Rental Agreements, Bank Statement showing the amount of sale </p>
                    <h6>5. Savings</h6>
                    <p>Bank Statement</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
import * as types from '@/types'
import { mapActions } from 'vuex'
export default {
    name: 'Questionnaire',
    mixins: [registerStepsMixins],
    data() {
        return {
            pageLoader: false,
            submitted: false,
            submitted_financial: false,
            submitted_doc: false,
            account: '',
            show_question: 0,
            ques_step: 0,

            document_popup: false,

            annual_income: '',
            net_worth: '',
            source_of_funds: '',
            deposit_amount: '',
            withdrawal_amount: '',

            uploadFiles: {},

            AddMoreDocument : [ { 'id' : 1 , 'file': '', 'name' : '', 'size': false, 'extension': false} ],

            ans_list: {
                '1': '',
                '2': '',
            },

            question_list: {
                "3": {
                    "question_id": "3",
                    "type": "Financial Information",
                    "question": "Estimated Annual Income (USD equivalent)",
                    "answers": [
                        { "ans_id": "0", "answer": "0 - 10,000" },
                        { "ans_id": "1", "answer": "10,000 - 50,000" },
                        { "ans_id": "2", "answer": "50,000 - 100,000" },
                        { "ans_id": "3", "answer": "100,000 - 200,000" },
                        { "ans_id": "4", "answer": "Above 200,000" }
                    ]
                },
                "4": {
                    "question_id": "4",
                    "type": " ",
                    "question": "Estimated Net Worth (USD equivalent)",
                    "answers": [
                        { "ans_id": "0", "answer": "0 - 50,000" },
                        { "ans_id": "1", "answer": "50,000 - 100,000" },
                        { "ans_id": "2", "answer": "100,000 - 300,000" },
                        { "ans_id": "3", "answer": "300,000 +" },
                    ]
                },
                "5": {
                    "question_id": "5",
                    "type": "",
                    "question": "What are the sources of your funds?",
                    "answers": [
                        { "ans_id": "0", "answer": "Salary" },
                        { "ans_id": "1", "answer": "Investment" },
                        { "ans_id": "2", "answer": "Inheritance" },
                        { "ans_id": "3", "answer": "Real Estate" },
                        { "ans_id": "4", "answer": "Savings" }
                    ]
                },
                "6": {
                    "question_id": "6",
                    "type": "Account Usage",
                    "question": "Expected Deposit Amount (Monthly)",
                    "answers": [
                        { "ans_id": "0", "answer": "Under $500,000" },
                        { "ans_id": "1", "answer": "500,000 - 2,000,000" },
                        { "ans_id": "2", "answer": "200,000 - 5,000,000" },
                        { "ans_id": "3", "answer": "500,000 - 10,000,000" },
                        { "ans_id": "4", "answer": "Above $10,000,000" }
                    ]
                },
                "7": {
                    "question_id": "7",
                    "type": "",
                    "question": "Expected Withdrawal Amount (Monthly)",
                    "answers": [
                        { "ans_id": "0", "answer": "Under $500,000" },
                        { "ans_id": "1", "answer": "500,000 - 2,000,000" },
                        { "ans_id": "2", "answer": "200,000 - 5,000,000" },
                        { "ans_id": "3", "answer": "500,000 - 10,000,000" },
                        { "ans_id": "4", "answer": "Above $10,000,000" }
                    ]
                }
            },
            statAns:{
                "3":"",
                "4":"",
                "5":"",
                "6":"",
                "7":"",
            },
            statAnsNum:"3"
        }
    },
    methods: {
        ...mapActions({
            _runstateLoad: types.RUN_STATE_LOAD
        }),
        AddMore(){
            this.AddMoreDocument.push({ 'id': this.AddMoreDocument[this.AddMoreDocument.length-1].id + 1 , 'file': '', 'name' : ''})
        },
        removeDocument(id){
            this.AddMoreDocument = this.AddMoreDocument.filter( value => value.id != id )
        },
        quesNext(key) {
            let _that = this
            this.$validator.validate().then(valid => {
                if (this.ans_list[key]) {
                    _that.show_question += 1
                }
            });
        },
        financialQuesNext() {
            let _that = this
            this.$validator.validate().then(valid => {
                if(valid){
                    _that.statAnsNum = (parseInt(_that.statAnsNum)+1).toString()
                }
            })
        },
        submit() {
            delete this.ans_list[0]
            let ans_list = []
            for (const key in this.ans_list) {
                if (this.question[key]) {
                    this.question[key].answers.forEach(val => {
                        if (val.ans_id == this.ans_list[key]) {
                            let d = { ...val }
                            d.type = this.question[key].type
                            ans_list.push(d)
                        }
                    })
                }
            }
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'ques_ans_array': ans_list,
                            'step': '4',
                        },
                        'localParams': {
                            "parameter": _that,
                        }
                    }
                    _that._runQuestion(input_json)
                } else {

                }
            });
        },
        submitFinancial(){
            const _that = this
            _that.submitted_financial = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'yearly_income': _that.annual_income,
                            'net_worth': _that.net_worth,
                            'source_of_fund': _that.source_of_funds,
                            'deposit_amount': _that.deposit_amount,
                            'withdrawal_amount': _that.withdrawal_amount,
                            'step': '5',
                        },
                        'localParams': {
                            "parameter": _that,
                        }
                    }
                    _that._runFinancialQuestion(input_json)
                } else {

                }
            });
        },
        sourceFiles(index,file){
            if( file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.totalSize ){
                this.notifiyFunc('Maximum files size of can be uploaded up to 20 MB','error')
                document.getElementById('Financial'+index).value= null;
                return;
            } else if(!['jpeg', 'jpg', 'png', 'pdf'].includes(file.type.toLowerCase().split('/')[1])){
                this.notifiyFunc('File type should be pdf, png, jpeg, jpg','error')
                document.getElementById('Financial'+index).value= null;
                return; 
            } else if(file.name){
                this.AddMoreDocument[index]['name'] = file.name
                this.AddMoreDocument[index]['file'] = file
            }
        },
        notifiyFunc(msg = '',type = 'info'){
            this.$notify({
                group: 'foo',
                type: type,
                text: msg,
                duration:10000,
                closeOnClick: true
            });
        },
        submitDoc(){
            if (this.pageLoader) {
                return;
            }
            const _that = this
            _that.submitted_doc = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let form_name = new FormData();
                    this.AddMoreDocument.forEach(item =>{
                        form_name.append('document[]', item.file,item.name)
                    })
                    form_name.append('documenttype','financial_statement')
                    form_name.append('step',6)
                    let input_json = {
                        'globalParams': {
                            'form': form_name,
                        },
                        'localParams' :{ "parameter" : _that , type : 'form'}
                    }
                    _that._runFinancialDocs(input_json)
                }
            });
        },
    },
    created() {
        this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this, 'page': 'question'}})
        // this.get_user.tier = 3
        // this.get_user.step = 3

        this._runGetQuestion({
            globalParams: {},
            localParams: { parameter: this },
        });
        setTimeout(() => {
            this._runGetStepInfo({ 'globalParams': { "step": '3' }, 'localParams': { "parameter": this, 'from': 'question' } })
        }, 1000);
    },

}
</script>



// WEBPACK FOOTER //
// src/components/website/questionnaire/questionnaire.vue